import {
  QUERY_PROGRESS_FAILED,
  QUERY_PROGRESS_NOT_STARTED,
  QUERY_PROGRESS_PENDING,
  QUERY_PROGRESS_SUCCEED,
} from "core/consts";
import aiApi from "core/model/api/endpoints/extractDocs";
import { getErrorMessage } from "core/model/utils/errors";
import { FileState, QueryProgress } from "core/types";
import { useCallback, useState } from "react";
import { useLoggedCareseeker } from "reduxentities/hooks";

export function useDeleteExtractedFile() {
  const careseeker = useLoggedCareseeker();
  const [progress, setProgress] = useState<QueryProgress>(
    QUERY_PROGRESS_NOT_STARTED,
  );
  const [error, setError] = useState<string | null>(null);

  const deleteExtract = useCallback(async (fileId: FileState["id"]) => {
    try {
      setProgress(QUERY_PROGRESS_PENDING);
      const result = await aiApi.extract.delete({
        careseekerId: careseeker?.id,
        fileId,
      });
      setProgress(QUERY_PROGRESS_SUCCEED);
      return result;
    } catch (err) {
      // if the document is not found, nothing to delete
      if (getErrorMessage(err) === "Document not found") {
        setProgress(QUERY_PROGRESS_SUCCEED);
        return;
      }
      setError(getErrorMessage(err));
      setProgress(QUERY_PROGRESS_FAILED);
    }
  }, []);

  return {
    deleteExtract,
    error,
    progress,
    resetProgress: () => setProgress(QUERY_PROGRESS_NOT_STARTED),
  };
}
